import { dashboardDeploymentsAPI } from './dashboard-deployments.api'
import type { DashboardDeploymentsResponse } from './dashboard-deployments.types'

/**
 * Dashboard deployments service composable — pure async business logic.
 *
 * NO reactive state (loading, error refs) — the store handles that.
 *
 * Architecture: View → Store → dashboard-deployments.composable.ts → dashboard-deployments.api.ts
 */
export function useDashboardDeploymentsService() {
  /**
   * List every merchant-dashboard deployment. Filtering is the caller's job.
   */
  const list = async (): Promise<DashboardDeploymentsResponse> => {
    return dashboardDeploymentsAPI.list()
  }

  return { list }
}
